export enum RoutesPldEnum {
    PLD_HOME = 'pld-comienzo' as any,
    PURPOSE = 'pld-proposito' as any,
    MONEY = 'pld-saldo-promedio' as any,
    CREDITS = 'pld-acreditaciones-mensuales' as any,
}
